import { initContentSlider } from "./content-slider.js";

const CARD_SLIDER_SELECTOR = ".card-slider__swiper";
const SLIDES_PER_VIEW = 3;

export const cardSlider = () => {
  initContentSlider({
    swiperSelector: CARD_SLIDER_SELECTOR,
    sectionClass: "card-slider",
    navPrevClass: "card-slider__nav--prev",
    navNextClass: "card-slider__nav--next",
    slidesPerView: SLIDES_PER_VIEW,
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 24 },
      575: { slidesPerView: 2, spaceBetween: 24 },
      1024: { slidesPerView: SLIDES_PER_VIEW, spaceBetween: 24 },
    },
  });
};
